import { WorkspaceService } from '@/services/workspace'
import {
  ApiErrorResponse,
  ApiIndividualResponse,
  ApiReactQueryOptions,
} from '@/types/api'
import { IWorkspace } from '@/types/workspace'
import { useQuery } from '@tanstack/react-query'

export const useWorkspace = (
  workspaceId: string | null,
  queryOptions?: ApiReactQueryOptions<ApiIndividualResponse<IWorkspace>>
) => {
  return useQuery<ApiIndividualResponse<IWorkspace>, ApiErrorResponse>({
    ...queryOptions,
    queryKey: ['workspaces', workspaceId],
    queryFn: () => WorkspaceService.getById(workspaceId),
    throwOnError: false,
  })
}
